// extracted by mini-css-extract-plugin
module.exports = {"alert":"alert_alert__2-ERc","error":"alert_error__2aJVI","success":"alert_success__2jFQW","info":"alert_info__rM1_8"};